<script>
  import conciliacaoProjetoServico from '../servico';

  const INTERVALO = 2000;
  const SEM_NOVIDADE_MS = 3 * 60 * 1000;

  const SITUACOES_CONTA = {
    fila: { rotulo: 'Na fila', icon: 'fa-clock-o', cls: 'fila', ordem: 3 },
    buscando: { rotulo: 'Buscando lançamentos', icon: 'fa-spinner fa-pulse', cls: 'ativa', ordem: 0 },
    conciliando: { rotulo: 'Conciliando', icon: 'fa-spinner fa-pulse', cls: 'ativa', ordem: 0 },
    enviando: { rotulo: 'Gravando no Manager', icon: 'fa-spinner fa-pulse', cls: 'ativa', ordem: 0 },
    erro: { rotulo: 'Erro', icon: 'fa-times-circle', cls: 'erro', ordem: 1 },
    ok: { rotulo: 'Concluída', icon: 'fa-check-circle', cls: 'ok', ordem: 4 }
  };

  const SITUACOES_ARQUIVO = {
    ENVIADO: { rotulo: 'Aguardando', cls: 'fila' },
    PROCESSADO: { rotulo: 'Virou lançamento', cls: 'ok' },
    SEM_CONTA: { rotulo: 'Conta fora do cadastro', cls: 'aviso' },
    SEM_LANCAMENTO: { rotulo: 'Sem lançamento', cls: 'aviso' },
    ERRO: { rotulo: 'Erro', cls: 'erro' }
  };

  export default {
    props: {
      jobId: { type: String, required: true }
    },
    data() {
      return {
        dados: null,
        falha: '',
        timer: null,
        destruido: false,
        avisouConclusao: false,
        ultimaAssinatura: '',
        ultimaNovidade: Date.now(),
        minimizando: false,
        estiloMinimizar: {},
        agora: Date.now(),
        aba: 'contas'
      };
    },
    computed: {
      isaac() { return (this.dados && this.dados.isaac) || {}; },
      progresso() { return this.isaac.progresso || {}; },
      statusIsaac() { return this.isaac.status || ''; },
      situacaoWeb() { return (this.dados && this.dados.situacao) || ''; },
      terminado() { return this.situacaoWeb === 'CONCLUIDO' || this.situacaoWeb === 'ERRO'; },
      comErro() { return this.situacaoWeb === 'ERRO' || this.statusIsaac === 'erro'; },
      etapa() {
        if (this.terminado) return this.comErro ? 'erro' : 'concluido';
        if (!this.statusIsaac || this.statusIsaac === 'enfileirado') return 'fila';
        return this.progresso.etapa || 'lendo_arquivos';
      },
      tituloEtapa() {
        const t = {
          fila: 'Na fila do Isaac Hub',
          lendo_arquivos: 'Lendo os arquivos',
          conciliando: 'Conciliando as contas',
          finalizando: 'Finalizando',
          concluido: 'Processamento concluído',
          erro: 'Processamento interrompido'
        };
        return t[this.etapa] || 'Processando';
      },
      subtituloEtapa() {
        const p = this.progresso;
        if (this.etapa === 'fila') return 'Aguardando a vez de processar. Outro envio pode estar em andamento.';
        if (this.etapa === 'lendo_arquivos') {
          return p.arquivos_total ? `${+p.arquivos_lidos || 0} de ${p.arquivos_total} arquivo(s) lido(s)` + (p.arquivo_atual ? ` · ${this.nomeCurto(p.arquivo_atual)}` : '') : 'Abrindo o pacote enviado';
        }
        if (this.etapa === 'conciliando') return `${+p.contas_concluidas || 0} de ${+p.contas_total || 0} conta(s) concluída(s)` + (+p.contas_erro ? ` · ${p.contas_erro} com erro` : '');
        if (this.etapa === 'finalizando') return 'Conferindo os arquivos que não viraram lançamento';
        if (this.etapa === 'erro') return (this.dados && this.dados.resumo) || this.isaac.detalhe || 'O Isaac Hub não concluiu o processamento.';
        return (this.dados && this.dados.resumo) || '';
      },
      percentual() {
        const p = this.progresso;
        if (this.terminado) return 100;
        if (this.etapa === 'fila') return 2;
        if (this.etapa === 'lendo_arquivos') return 3 + Math.round(27 * ((+p.arquivos_lidos || 0) / Math.max(+p.arquivos_total || 1, 1)));
        if (this.etapa === 'conciliando') return 30 + Math.round(65 * ((+p.contas_concluidas || 0) / Math.max(+p.contas_total || 1, 1)));
        if (this.etapa === 'finalizando') return 97;
        return 100;
      },
      contas() {
        const pc = this.progresso.por_conta || {};
        return Object.keys(pc).map(k => pc[k]).sort((a, b) => {
          const oa = (SITUACOES_CONTA[a.situacao] || SITUACOES_CONTA.fila).ordem;
          const ob = (SITUACOES_CONTA[b.situacao] || SITUACOES_CONTA.fila).ordem;
          return oa !== ob ? oa - ob : String(a.numero || '').localeCompare(String(b.numero || ''));
        });
      },
      eventos() { return (this.progresso.eventos || []).slice().reverse(); },
      arquivos() { return (this.dados && this.dados.arquivos) || []; },
      naoProcessados() { return this.isaac.nao_processados || []; },
      qtdProcessadas() { return +this.isaac.processadas || 0; },
      qtdErros() { return (this.isaac.erros || []).length; },
      semNovidade() { return !this.terminado && this.agora - this.ultimaNovidade > SEM_NOVIDADE_MS; }
    },
    methods: {
      consultar() {
        if (this.destruido) return;
        conciliacaoProjetoServico.acompanharEnvioExtrato(this.jobId)
          .then(dados => {
            if (this.destruido) return;
            this.dados = dados;
            this.falha = '';
            this.agora = Date.now();
            const p = (dados.isaac && dados.isaac.progresso) || {};
            const assinatura = [dados.situacao, dados.isaac && dados.isaac.status, p.atualizado_em, (p.eventos || []).length].join('|');
            if (assinatura !== this.ultimaAssinatura) { this.ultimaAssinatura = assinatura; this.ultimaNovidade = Date.now(); }
            this.$emit('progresso', this.resumoProgresso());
            if (this.terminado) {
              if (!this.avisouConclusao) { this.avisouConclusao = true; this.$emit('concluido', dados); }
              return;
            }
            this.agendar();
          })
          .catch(res => {
            if (this.destruido) return;
            this.agora = Date.now();
            this.falha = res && res.body && res.body.message ? res.body.message : 'Não foi possível consultar o andamento.';
            this.agendar();
          });
      },
      resumoProgresso() {
        const p = this.progresso;
        let detalhe = '';
        if (this.etapa === 'fila') detalhe = 'na fila do Isaac';
        else if (this.etapa === 'lendo_arquivos') detalhe = `lendo ${+p.arquivos_lidos || 0}/${+p.arquivos_total || 0} arquivos`;
        else if (this.etapa === 'conciliando') detalhe = `${+p.contas_concluidas || 0}/${+p.contas_total || 0} contas`;
        else if (this.etapa === 'finalizando') detalhe = 'finalizando';
        return { etapa: this.etapa, percentual: this.percentual, detalhe, terminado: this.terminado, comErro: this.comErro, resumo: (this.dados && this.dados.resumo) || '' };
      },
      sair() {
        if (this.terminado || this.minimizando) { this.$emit('fechar', this.terminado); return; }
        const destino = document.querySelector('.btn-passo.passo-1');
        const modal = this.$refs.modal;
        if (!destino || !modal) { this.$emit('fechar', false); return; }
        const d = destino.getBoundingClientRect();
        const m = modal.getBoundingClientRect();
        const dx = (d.left + d.width / 2) - (m.left + m.width / 2);
        const dy = (d.top + d.height / 2) - (m.top + m.height / 2);
        this.minimizando = true;
        this.estiloMinimizar = { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: 0 };
        setTimeout(() => {
          this.$emit('fechar', false);
          this.minimizando = false;
          this.estiloMinimizar = {};
        }, 450);
      },
      agendar() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.consultar(), INTERVALO);
      },
      situacaoConta(c) { return SITUACOES_CONTA[c.situacao] || SITUACOES_CONTA.fila; },
      situacaoArquivo(a) { return SITUACOES_ARQUIVO[a.situacao] || { rotulo: a.situacao, cls: 'fila' }; },
      nomeCurto(nome) { const n = String(nome || '').replace(/\\/g, '/'); return n.substring(n.lastIndexOf('/') + 1); },
      pasta(nome) { const n = String(nome || '').replace(/\\/g, '/'); const i = n.lastIndexOf('/'); return i > 0 ? n.substring(0, i) : ''; },
      detalheArquivo(a) {
        if (a.detalhe) return a.detalhe;
        const d = this.naoProcessados.find(x => this.nomeCurto(x.arquivo) === this.nomeCurto(a.nomeArquivo));
        return d ? d.detalhe : '';
      }
    },
    created() { this.consultar(); },
    beforeDestroy() { this.destruido = true; clearTimeout(this.timer); }
  };
</script>

<template>
  <div class="aen-ov" :class="{ 'aen-ov-saindo': minimizando }">
    <div class="aen-modal" ref="modal" :class="{ 'aen-minimizando': minimizando }" :style="estiloMinimizar">
      <div class="aen-head">
        <div class="aen-head-ic" :class="'aen-ic-' + etapa">
          <i class="fa" :class="etapa === 'concluido' ? 'fa-check' : (etapa === 'erro' ? 'fa-exclamation-triangle' : 'fa-cog fa-spin')"></i>
        </div>
        <div class="aen-head-txt">
          <h4>{{ tituloEtapa }}</h4>
          <small>{{ subtituloEtapa }}</small>
        </div>
        <div class="aen-head-resumo" v-if="dados">
          <b>{{ percentual }}%</b>
          <small>enviado {{ dados.dataEnvio }}</small>
        </div>
      </div>

      <div class="aen-barra-wrap">
        <div class="aen-barra"><div class="aen-barra-fill" :class="{ 'aen-fill-ok': etapa === 'concluido', 'aen-fill-erro': etapa === 'erro', 'aen-fill-anim': !terminado }" :style="{ width: percentual + '%' }"></div></div>
        <div class="aen-numeros" v-if="progresso.contas_total || progresso.arquivos_total">
          <span><i class="fa fa-file-text-o"></i> {{ +progresso.arquivos_lidos || 0 }}/{{ +progresso.arquivos_total || 0 }} arquivos</span>
          <span><i class="fa fa-university"></i> {{ +progresso.contas_concluidas || 0 }}/{{ +progresso.contas_total || 0 }} contas</span>
          <span v-if="+progresso.contas_erro" class="aen-num-erro"><i class="fa fa-times-circle"></i> {{ progresso.contas_erro }} com erro</span>
        </div>
      </div>

      <div v-if="semNovidade" class="aen-alerta"><i class="fa fa-exclamation-circle"></i> O Isaac Hub está há mais de 3 minutos sem dar notícia deste envio. Ele pode estar ocupado com outro lote ou sem conseguir falar com o Manager.</div>
      <div v-if="falha" class="aen-alerta"><i class="fa fa-exclamation-circle"></i> {{ falha }} Tentando de novo...</div>
      <div v-else-if="dados && dados.falhaIsaac && !terminado" class="aen-alerta"><i class="fa fa-exclamation-circle"></i> {{ dados.falhaIsaac }}</div>

      <div v-if="terminado" class="aen-final" :class="{ 'aen-final-erro': comErro }">
        <div class="aen-final-kpi"><b>{{ qtdProcessadas }}</b><small>conta{{ qtdProcessadas === 1 ? '' : 's' }} gravada{{ qtdProcessadas === 1 ? '' : 's' }}</small></div>
        <div class="aen-final-kpi"><b>{{ qtdErros }}</b><small>com erro</small></div>
        <div class="aen-final-kpi"><b>{{ naoProcessados.length }}</b><small>arquivo{{ naoProcessados.length === 1 ? '' : 's' }} sem lançamento</small></div>
      </div>

      <div class="aen-abas">
        <button type="button" :class="{ ativo: aba === 'contas' }" @click="aba = 'contas'"><i class="fa fa-university"></i> Contas <span class="aen-n">{{ contas.length }}</span></button>
        <button type="button" :class="{ ativo: aba === 'eventos' }" @click="aba = 'eventos'"><i class="fa fa-list-ul"></i> O que está acontecendo <span class="aen-n">{{ eventos.length }}</span></button>
        <button type="button" :class="{ ativo: aba === 'arquivos' }" @click="aba = 'arquivos'"><i class="fa fa-file-text-o"></i> Arquivos <span class="aen-n">{{ arquivos.length }}</span></button>
      </div>

      <div class="aen-corpo">
        <div v-if="!dados" class="aen-msg"><i class="fa fa-spinner fa-pulse"></i> Consultando o andamento...</div>

        <template v-else-if="aba === 'contas'">
          <div v-if="!contas.length" class="aen-msg">{{ etapa === 'fila' || etapa === 'lendo_arquivos' ? 'As contas aparecem aqui assim que a leitura dos arquivos terminar.' : 'Nenhuma conta para conciliar neste envio.' }}</div>
          <div v-for="c in contas" :key="c.idconta" class="aen-conta" :class="'aen-c-' + situacaoConta(c).cls">
            <i class="fa aen-conta-ic" :class="situacaoConta(c).icon"></i>
            <div class="aen-conta-txt">
              <b>{{ c.numero || c.idconta }}</b><small v-if="c.banco"> · banco {{ c.banco }}</small>
              <div v-if="c.erro" class="aen-conta-erro">{{ c.erro }}</div>
            </div>
            <span class="aen-conta-meta">{{ c.linhas }} linha{{ c.linhas === 1 ? '' : 's' }}<template v-if="c.conciliadas !== null && c.conciliadas !== undefined"> · {{ c.conciliadas }} conciliada{{ c.conciliadas === 1 ? '' : 's' }}</template></span>
            <span class="aen-conta-sit">{{ situacaoConta(c).rotulo }}</span>
          </div>
        </template>

        <template v-else-if="aba === 'eventos'">
          <div v-if="!eventos.length" class="aen-msg">Aguardando o Isaac Hub começar.</div>
          <div v-for="(e, i) in eventos" :key="eventos.length - i" class="aen-ev" :class="'aen-ev-' + e.tipo">
            <span class="aen-ev-hora">{{ e.hora }}</span>
            <span class="aen-ev-txt">{{ e.texto }}</span>
          </div>
        </template>

        <template v-else>
          <div v-for="a in arquivos" :key="a.nomeArquivo" class="aen-arq">
            <div class="aen-arq-txt">
              <b>{{ nomeCurto(a.nomeArquivo) }}</b><small v-if="pasta(a.nomeArquivo)">{{ pasta(a.nomeArquivo) }}</small>
              <div v-if="detalheArquivo(a)" class="aen-arq-det"><i class="fa fa-info-circle"></i> {{ detalheArquivo(a) }}</div>
            </div>
            <span class="aen-arq-sit" :class="'aen-s-' + situacaoArquivo(a).cls">{{ situacaoArquivo(a).rotulo }}</span>
          </div>
        </template>
      </div>

      <div class="aen-foot">
        <div class="aen-foot-info">{{ terminado ? '' : 'Pode fechar: o processamento continua e a lista avisa quando terminar.' }}</div>
        <button v-if="terminado" type="button" class="btn btn-primary aen-mais" @click="$emit('enviar-mais')"><i class="fa fa-cloud-upload"></i> Enviar mais arquivos</button>
        <button type="button" class="aen-sair" @click="sair"><i class="fa fa-sign-out"></i> {{ terminado ? 'Sair' : 'Sair e continuar em segundo plano' }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .aen-ov { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(16,24,40,.45); z-index: 2100; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .aen-ov { transition: background .45s ease; }
  .aen-ov.aen-ov-saindo { background: rgba(16,24,40,0); pointer-events: none; }
  .aen-modal.aen-minimizando { transition: transform .45s cubic-bezier(.55,0,.75,.2), opacity .45s ease-in; }
  .aen-modal { width: 780px; max-width: 97vw; max-height: 90vh; display: flex; flex-direction: column; background: #fff; border-radius: 8px; box-shadow: 0 18px 48px rgba(16,24,40,.28); overflow: hidden; }
  .aen-head { flex: 0 0 auto; display: flex; align-items: center; gap: 14px; padding: 15px 20px; background: #f7f9fa; border-bottom: 1px solid #e6e9ed; }
  .aen-head-ic { flex: none; width: 38px; height: 38px; border-radius: 8px; background: #e8f0fa; color: #2b6cb0; display: flex; align-items: center; justify-content: center; font-size: 18px; }
  .aen-head-ic.aen-ic-concluido { background: #e3f6ee; color: #1a8a5a; }
  .aen-head-ic.aen-ic-erro { background: #fdecec; color: #c0392b; }
  .aen-head-txt { flex: 1 1 auto; min-width: 0; }
  .aen-head-txt h4 { margin: 0; font-size: 16px; font-weight: 600; color: #1c2024; }
  .aen-head-txt small { display: block; margin-top: 2px; font-size: 12px; color: #6b747e; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .aen-head-resumo { flex: none; text-align: right; }
  .aen-head-resumo b { font-size: 20px; color: #1c2024; }
  .aen-head-resumo small { display: block; font-size: 11.5px; color: #8a939c; }

  .aen-barra-wrap { flex: 0 0 auto; padding: 12px 20px 10px; border-bottom: 1px solid #eef1f4; }
  .aen-barra { height: 8px; border-radius: 4px; background: #eef1f4; overflow: hidden; }
  .aen-barra-fill { height: 100%; background: #2b6cb0; border-radius: 4px; transition: width .6s ease; }
  .aen-barra-fill.aen-fill-anim { background-image: linear-gradient(45deg, rgba(255,255,255,.18) 25%, transparent 25%, transparent 50%, rgba(255,255,255,.18) 50%, rgba(255,255,255,.18) 75%, transparent 75%, transparent); background-size: 16px 16px; animation: aen-listras 1s linear infinite; }
  .aen-barra-fill.aen-fill-ok { background-color: #1ab394; }
  .aen-barra-fill.aen-fill-erro { background-color: #ed5565; }
  @keyframes aen-listras { from { background-position: 0 0; } to { background-position: 16px 0; } }
  .aen-numeros { display: flex; gap: 16px; margin-top: 8px; font-size: 12px; color: #5b6570; }
  .aen-numeros .fa { color: #8a9bb0; margin-right: 3px; }
  .aen-num-erro, .aen-num-erro .fa { color: #c0392b; }

  .aen-alerta { flex: 0 0 auto; margin: 10px 20px 0; padding: 8px 12px; border-radius: 6px; background: #fff8e6; border: 1px solid #f3dfa8; color: #8a6514; font-size: 12.5px; }

  .aen-final { flex: 0 0 auto; display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin: 12px 20px 0; padding: 10px 14px; border-radius: 7px; background: #f0faf5; border: 1px solid #cdebdc; }
  .aen-final.aen-final-erro { background: #fdf1f1; border-color: #f0d2d2; }
  .aen-final-kpi { min-width: 110px; }
  .aen-final-kpi b { display: block; font-size: 18px; color: #1c2024; line-height: 1.1; }
  .aen-final-kpi small { font-size: 11.5px; color: #6b747e; }
  .aen-final-txt { flex: 1 1 100%; font-size: 12.5px; color: #1a6b48; }

  .aen-abas { flex: 0 0 auto; display: flex; margin: 12px 20px 0; border: 1px solid #c9d6e6; border-radius: 7px; overflow: hidden; align-self: flex-start; }
  .aen-abas button { height: 32px; padding: 0 12px; border: none; background: #fff; color: #4b545e; font-size: 12.5px; font-weight: 600; white-space: nowrap; }
  .aen-abas button + button { border-left: 1px solid #c9d6e6; }
  .aen-abas button .fa { margin-right: 4px; color: #8a9bb0; }
  .aen-abas button.ativo { background: #e8f0fa; color: #1e4f86; }
  .aen-abas button.ativo .fa { color: #2b6cb0; }
  .aen-n { display: inline-block; min-width: 20px; margin-left: 4px; padding: 0 6px; border-radius: 9px; background: #eef1f4; color: #5b6570; font-size: 11px; text-align: center; }
  .aen-abas button.ativo .aen-n { background: #2b6cb0; color: #fff; }

  .aen-corpo { flex: 1 1 auto; min-height: 240px; overflow: auto; padding: 10px 20px 14px; }
  .aen-msg { padding: 40px 10px; text-align: center; color: #8a939c; font-size: 13px; }

  .aen-conta { display: flex; align-items: center; gap: 10px; padding: 8px 12px; margin-bottom: 6px; border: 1px solid #e3e8ee; border-left: 3px solid #c3ccd6; border-radius: 7px; font-size: 12.5px; }
  .aen-conta-ic { flex: none; width: 16px; text-align: center; color: #9aa3ac; }
  .aen-conta-txt { flex: 1 1 auto; min-width: 0; }
  .aen-conta-txt b { color: #1c2024; }
  .aen-conta-txt small { color: #8a939c; }
  .aen-conta-erro { margin-top: 2px; color: #a13c3c; font-size: 11.5px; }
  .aen-conta-meta { flex: none; color: #6b747e; font-size: 11.5px; }
  .aen-conta-sit { flex: none; min-width: 130px; text-align: right; font-weight: 600; color: #6b747e; font-size: 11.5px; }
  .aen-c-ativa { border-left-color: #2b6cb0; background: #f7fafd; }
  .aen-c-ativa .aen-conta-ic, .aen-c-ativa .aen-conta-sit { color: #2b6cb0; }
  .aen-c-ok { border-left-color: #1ab394; }
  .aen-c-ok .aen-conta-ic, .aen-c-ok .aen-conta-sit { color: #1a8a5a; }
  .aen-c-erro { border-left-color: #ed5565; background: #fffafa; }
  .aen-c-erro .aen-conta-ic, .aen-c-erro .aen-conta-sit { color: #c0392b; }

  .aen-ev { display: flex; gap: 10px; padding: 5px 0; border-bottom: 1px dashed #eef1f4; font-size: 12.5px; color: #3b444d; }
  .aen-ev-hora { flex: none; width: 62px; color: #8a939c; font-family: Consolas, monospace; font-size: 11.5px; padding-top: 1px; }
  .aen-ev-txt { flex: 1 1 auto; min-width: 0; word-break: break-word; }
  .aen-ev-ok .aen-ev-txt { color: #1a6b48; }
  .aen-ev-aviso .aen-ev-txt { color: #8a6514; }
  .aen-ev-erro .aen-ev-txt { color: #a13c3c; font-weight: 600; }

  .aen-arq { display: flex; align-items: center; gap: 10px; padding: 8px 12px; margin-bottom: 6px; border: 1px solid #e3e8ee; border-radius: 7px; font-size: 12.5px; }
  .aen-arq-txt { flex: 1 1 auto; min-width: 0; }
  .aen-arq-txt b { color: #1c2024; word-break: break-all; }
  .aen-arq-txt small { display: block; color: #8a939c; font-size: 11px; }
  .aen-arq-det { margin-top: 3px; color: #8a6514; font-size: 11.5px; }
  .aen-arq-sit { flex: none; padding: 2px 9px; border-radius: 10px; font-size: 11px; font-weight: 600; background: #eef1f4; color: #5b6570; }
  .aen-s-ok { background: #e3f6ee; color: #1a8a5a; }
  .aen-s-aviso { background: #fff3d9; color: #8a6514; }
  .aen-s-erro { background: #fdecec; color: #c0392b; }

  .aen-foot { flex: 0 0 auto; display: flex; align-items: center; gap: 12px; padding: 12px 20px; border-top: 1px solid #e6e9ed; background: #f7f9fa; }
  .aen-foot-info { flex: 1 1 auto; font-size: 12px; color: #6b747e; }
  .aen-mais { height: 34px; padding: 0 14px; font-size: 13px; font-weight: 600; margin: 0; }
  .aen-sair { height: 34px; padding: 0 14px; border-radius: 4px; background: #fdf1f1; border: 1px solid #e4d7d7; color: #a13c3c; font-weight: 600; font-size: 13px; }
  .aen-sair:hover { background: #fbe7e7; border-color: #d9c2c2; }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/conciliacao-projeto/componentes/AcompanhamentoEnvioModal.vue